import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrembl = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M31.7 11.8H20.8V1l10.9 10.8z" }), /* @__PURE__ */ _jsx("path", { d: "M31.7 14.2v25.2H.4V1h18v13.2h13.3z" })]
});
export default SvgTrembl;
